import src from "IMAGE";
export default { src, width: 303, height: 135, blurWidth: 0, blurHeight: 0};
